import { RestrictionsFormData } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import {
  CorpUIResponse,
  CorpSubscriptionFundingType,
  SSOIdentifierEnum,
  InvoicingSubtotalMethod,
} from 'src/types/Corp';

export type GhPlusSubscriptionFundingFormField =
  | CorpSubscriptionFundingType.CORP
  | CorpSubscriptionFundingType.EMPLOYEE;

export interface GhPlusSubscriptionFormFields {
  funding: GhPlusSubscriptionFundingFormField;
  trialLengthDays?: string;
  monthlyFeeField?: number;
  monthlyFeeSelect?: string;
  startDate?: string;
}

export enum ReportingOption {
  NONE_REPORTING_OPTION = 'none',
  LOCATIONS_REPORTING_OPTION = 'locations',
  DEPARTMENTS_REPORTING_OPTION = 'departments',
}

export enum CorpInvoicingMethod {
  SINGLE_OPTION = 'SINGLE',
  SUBTOTAL_OPTION = 'SUBTOTAL',
  MULTI_OPTION = 'MULTI',
}

export enum CorpInvoicingPeriod {
  WEEKLY = 'FREQ=WEEKLY;INTERVAL=1;BYDAY=MO',
  BIWEEKLY = 'FREQ=WEEKLY;INTERVAL=2;BYDAY=MO',
  MONTHLY = 'FREQ=MONTHLY;BYMONTHDAY=1',
}

export type DinerNotificationPreferencesFormData = Record<
  string,
  string | boolean
>;

export type SFTPOptions = {
  sftpEmployeesEnabled: boolean | string;
  sftpExpenseCodesEnabled: boolean | string;
};

export interface CorporateFormFields {
  name: string;
  clientId: string;
  parentId?: string;
  markets: string;
  invoiceTimeZone: string;
  phoneNumber: string;
  salesPersonCode: string;
  expenseCodeAliasSingular: string;
  brand: string;
  effectiveDate: Date;
  automatedEmailsEnabled: boolean;
  autoInvoicingEnabled: boolean;
  allocationsPermitted: boolean;
  groupOrderEnabled: boolean;
  intacctTermName: string;
  intacctStatus?: string;
  firmTransactionFee: string;
  ghPlusEnabled?: boolean;
  orderingPolicyEnabled?: boolean;
  orderPolicyId?: string;
  ghPlusSubscription?: GhPlusSubscriptionFormFields;
  sftpNotificationEmailsString?: string;
  sftpOptions: SFTPOptions;
  firstInvoiceDate?: string;
  fileEncryptionEnabled?: boolean;
  enableSFTP?: boolean;
  universalAccountsEnabled: boolean;
  piiProtectedMarketing: boolean;
  taxExemptEnabled: boolean;
  disableMealCreditGracePeriod: boolean;
  maxCreditCardCharge?: number | string;
  invoicePaymentMethod?: string;
  ssoEnabled?: boolean;
  ssoIdentifier?: SSOIdentifierEnum;
  ssoUniqueIdentifier?: string;
  ssoProviderId?: string;
  ssoRedirectEnabled?: boolean;
  ssoRedirectUrl?: string;
  passwordRestricted?: boolean;
  passwordRestrictedToggleLock?: boolean;
  reporting: ReportingOption;
  invoiceContactFirstName: string;
  invoiceContactLastName: string;
  invoiceContactEmail: string;
  invoiceContactPhoneNumber: string;
  invoiceContactCity: string;
  invoiceContactAddress1: string;
  invoiceContactAddress2?: string;
  invoiceContactZip: string;
  invoiceContactState: string;
  invoicingMethod: CorpInvoicingMethod;
  invoicingSubtotalMethod: InvoicingSubtotalMethod;
  invoiceRrule: CorpInvoicingPeriod;
  dinerLocationRequired: boolean;
  dinerDepartmentRequired: boolean;
  dinerNotificationPreferences: DinerNotificationPreferencesFormData;
  enableDinerNotificationPreferences: boolean;
  cateringServiceFee?: string;
  enableMerchantRestrictions: boolean;
  defaultMerchantRestrictions: RestrictionsFormData;
  enableItemRestrictions: boolean;
  defaultItemRestrictions: RestrictionsFormData;
  subDepartmentEnabled?: boolean;
  locationInternalIdEnabled?: boolean;
}

export interface CorporateFormProps {
  corpData?: CorpUIResponse;
  defaultValues: CorporateFormFields;
  onSubmit: (data: CorporateFormFields) => Promise<void>;
  isEditPage?: boolean;
  isParentPage?: boolean;
}
